import { ApolloProvider } from '@apollo/client';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import {
  DialogDisplay,
  DialogProvider,
  GoogleAuthProvider,
  MenuDisplay,
  MenuProvider,
  NotificationDisplay,
  NotificationProvider,
  TutorialProvider,
  UpdateNotification,
} from '@prismamedia/one-components';
import { setDefaultOptions } from 'date-fns';
import { fr } from 'date-fns/locale';
import { FC } from 'react';
import ReactGA from 'react-ga4';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter5Adapter } from 'use-query-params/adapters/react-router-5';
import { client } from './apollo';
import './App.css';
import './megadraft.css';
import { Routing } from './routing';
import { theme } from './theme';

setDefaultOptions({ locale: fr });

ReactGA.initialize(config.GA_ID, {
  gaOptions: {
    debug_mode: ['test', 'development'].includes(process.env.NODE_ENV),
  },
});

export const App: FC = () => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <RecoilRoot>
        <CssBaseline>
          <GoogleAuthProvider>
            <ApolloProvider client={client}>
              <NotificationProvider>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={fr}>
                  <BrowserRouter>
                    <QueryParamProvider adapter={ReactRouter5Adapter}>
                      <DialogProvider>
                        <MenuProvider>
                          <TutorialProvider>
                            <Routing />
                            <MenuDisplay />
                            <NotificationDisplay />
                            <DialogDisplay />
                            <UpdateNotification />
                          </TutorialProvider>
                        </MenuProvider>
                      </DialogProvider>
                    </QueryParamProvider>
                  </BrowserRouter>
                </LocalizationProvider>
              </NotificationProvider>
            </ApolloProvider>
          </GoogleAuthProvider>
        </CssBaseline>
      </RecoilRoot>
    </ThemeProvider>
  </StyledEngineProvider>
);
